import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  list: [],
  users: [],
  selected: null,
  selectedCollections: [],
};

const collectionsSlice = createSlice({
  name: "collections",
  initialState: INITIAL_STATE,
  reducers: {
    setList: (state, action) => {
      state.list = action.payload;
    },
    setUsers: (state, action) => {
      state.users = action.payload;
    },
    removeCollection: (state, action) => {
      state.list = state.list.filter(
        (collection) => collection.id !== action.payload
      );
    },
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    toggleCollectionSelection: (state, action) => {
      const collection = action.payload;
      const index = state.selectedCollections.findIndex(
        (c) => c.id === collection.id
      );
      if (index === -1) {
        state.selectedCollections.push(collection);
      } else {
        state.selectedCollections.splice(index, 1);
      }
    },
    setSelectedCollections: (state, action) => {
      state.selectedCollections = action.payload;
    },
    clearSelectedCollections: (state) => {
      state.selectedCollections = [];
    },
  },
});

export const {
  setList,
  setUsers,
  setSelected,
  removeCollection,
  toggleCollectionSelection,
  setSelectedCollections,
  clearSelectedCollections,
} = collectionsSlice.actions;

export default collectionsSlice.reducer;
